export const UPDATE_SITE_SETTINGS_REQUEST = 'UPDATE_SITE_SETTINGS_REQUEST';
export const FETCH_EMAIL_VALIDATION_REQUEST = 'FETCH_EMAIL_VALIDATION_REQUEST';
export const FETCH_USERS_REQUEST = 'FETCH_USERS_REQUEST';
export const FETCH_USER_ATTRIBUTES_REQUEST = 'FETCH_USER_ATTRIBUTES_REQUEST';
export const FETCH_SUBSCRIPTION_GROUPS_REQUEST = 'FETCH_SUBSCRIPTION_GROUPS_REQUEST';
export const ADD_FROM_NAME_REQUEST = 'ADD_FROM_NAME_REQUEST';
export const REMOVE_FROM_NAME_REQUEST = 'REMOVE_FROM_NAME_REQUEST';
export const ADD_EMAIL_ADDRESS_REQUEST = 'ADD_EMAIL_ADDRESS_REQUEST';
export const REMOVE_EMAIL_ADDRESS_REQUEST = 'REMOVE_EMAIL_ADDRESS_REQUEST';
export const PORTAL_EMAIL_STATUS_REQUEST = 'PORTAL_EMAIL_STATUS_REQUEST';
export const FETCH_CONDITIONALLY_PUBLISH_REQUEST = 'FETCH_CONDITIONALLY_PUBLISH_REQUEST';
export const FETCH_IS_CONVERTIBLE_TO_DD_REQUEST = 'FETCH_IS_CONVERTIBLE_TO_DD_REQUEST';
export const FETCH_DKIM_DOMAINS_REQUEST = 'FETCH_DKIM_DOMAINS_REQUEST';
export const FETCH_DOMAINS_REQUEST = 'FETCH_DOMAINS_REQUEST';
export const FETCH_CUSTOM_OBJECTS_REQUEST = 'FETCH_CUSTOM_OBJECTS_REQUEST';
export const FETCH_ECOMM_SOURCES_REQUEST = 'FETCH_ECOMM_SOURCES_REQUEST';
export const FETCH_CURRENCY_INFORMATION_REQUEST = 'FETCH_CURRENCY_INFORMATION_REQUEST';
export const FETCH_SHOPIFY_STORES_REQUEST = 'FETCH_SHOPIFY_STORES_REQUEST';
export const FETCH_SAVED_SECTIONS_REQUEST = 'FETCH_SAVED_SECTIONS_REQUEST';
export const FETCH_SAVED_SECTION_META_REQUEST = 'FETCH_SAVED_SECTION_META_REQUEST';
export const SAVE_SECTION_REQUEST = 'SAVE_SECTION_REQUEST';
export const CREATE_SIMPLE_WORKFLOW_REQUEST = 'CREATE_SIMPLE_WORKFLOW_REQUEST';
export const FETCH_SIMPLE_WORKFLOWS_REQUEST = 'FETCH_SIMPLE_WORKFLOWS_REQUEST';
export const FETCH_PRODUCTS_COUNT_REQUEST = 'FETCH_PRODUCTS_COUNT_REQUEST';
export const FETCH_DEDICATE_IP_SETUP_REQUEST = 'FETCH_DEDICATE_IP_SETUP_REQUEST';
export const FETCH_PAYMENT_ELIGIBILITY_REQUEST = 'FETCH_PAYMENT_ELIGIBILITY_REQUEST';
export const FETCH_PLAIN_TEXT_REQUEST = 'FETCH_PLAIN_TEXT_REQUEST';
export const FETCH_LITMUS_HISTORY_REQUEST = 'FETCH_LITMUS_HISTORY_REQUEST';
export const FETCH_LITMUS_CLIENTS_REQUEST = 'FETCH_LITMUS_CLIENTS_REQUEST';
export const UPDATE_CAN_SPAM_SETTINGS_REQUEST = 'UPDATE_CAN_SPAM_SETTINGS_REQUEST';

// Email Template Editor request keys
export const FETCH_TEMPLATE_SCHEMA_REQUEST = 'FETCH_TEMPLATE_SCHEMA_REQUEST';
export const RESTORE_TEMPLATE_REVISION_REQUEST = 'RESTORE_TEMPLATE_REVISION_REQUEST';